import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { saveFlow } from "../../../redux/actions/integrationActions";
import FlowGroupNameEditor from "./FlowGroupNameEditor";

const SetFlowGroupMenuItem = ({ flow, onClickCallback }) => {
  const [groupName, setGroupName] = useState(flow?.groupName || "");
  const dispatch = useDispatch();

  useEffect(() => {
    setGroupName(flow?.groupName || "");
  }, [flow]);

  const handleSave = () => {
    dispatch(
      saveFlow({
        ...flow,
        groupName: groupName.trim(),
      }, false)
    );
    onClickCallback();
  };

  const handleClear = () => {
    setGroupName("");
    dispatch(
      saveFlow({
        ...flow,
        groupName: "",
      }, false)
    );
    onClickCallback();
  };

  return (
    <FlowGroupNameEditor value={groupName} onChange={setGroupName} onPrimaryAction={handleSave} onSecondaryAction={handleClear} />
  );
};

export default SetFlowGroupMenuItem;
